"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.fit = function (parent, child) {
  var fitMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fill';

  if (fitMode === 'scale-down') {
    if (child.width <= parent.width && child.height <= parent.height) {
      fitMode = 'none';
    } else {
      fitMode = 'contain';
    }
  }

  if (fitMode === 'cover' || fitMode === 'contain') {
    var wr = parent.width / child.width;
    var hr = parent.height / child.height;
    var ratio = fitMode === 'cover' ? Math.max(wr, hr) : Math.min(wr, hr);
    var width = child.width * ratio;
    var height = child.height * ratio;
    var size = {
      width: width,
      height: height
    };
    return size;
  }

  if (fitMode === 'none') return child; // default case, fitMode === 'fill'

  return parent;
};

exports.position = function (parent, child) {
  var left = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '50%';
  var top = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '50%';
  var x = lengthToPixels(left, parent.width, child.width);
  var y = lengthToPixels(top, parent.height, child.height);
  var point = {
    x: x,
    y: y
  };
  return point;
};

exports.fitAndPosition = function (parent, child) {
  var fitMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fill';
  var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '50%';
  var top = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '50%';
  var fitted = exports.fit(parent, child, fitMode);

  var _exports$position = exports.position(parent, fitted, left, top),
      x = _exports$position.x,
      y = _exports$position.y;

  var width = fitted.width,
      height = fitted.height;
  var rect = {
    x: x,
    y: y,
    width: width,
    height: height
  };
  return rect;
};

var lengthToPixels = function lengthToPixels(length, parent, child) {
  return length.endsWith('%') ? (parent - child) * (parseFloat(length) / 100) : parseFloat(length);
};